import React, { FC, ReactElement, MouseEvent } from 'react'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const PlusCircleIcon: FC<{
	className?: string
	width?: number
	height?: number
	onClick?: (evt: MouseEvent) => void
}> = (props): ReactElement => {
	return (
		<svg
			onClick={props.onClick}
			viewBox="0 0 24 24"
			fill="none"
			className={props.className}
			width={props.width}
			height={props.height}
			role={props.onClick ? "button" : undefined}
			tabIndex={props.onClick ? 0 : undefined}
			onKeyDown={onKeyboardClick(props.onClick)}
		>
			<path d="M12 22C6.52 22 2 17.48 2 12C2 6.53 6.52 2 11.99 2C17.47 2 22 6.53 22 12C22 17.48 17.48 22 12 22ZM10.94 16.77C11.32 16.77 11.65 16.57 11.88 16.23L16.36 9.32C16.51 9.09 16.62 8.84 16.62 8.61C16.62 8.07 16.14 7.7 15.62 7.7C15.29 7.7 15 7.89 14.77 8.24L10.91 14.42L9.13 12.19C8.88 11.88 8.63 11.76 8.32 11.76C7.78 11.76 7.36 12.19 7.36 12.73C7.36 12.99 7.45 13.22 7.64 13.46L9.95 16.24C10.24 16.59 10.54 16.77 10.94 16.77Z" />
		</svg>
	)
}

export default PlusCircleIcon
